import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import * as Msal from 'msal';

import { Button } from '@components/button';
import { IconEmail } from '@components/icons/email';
import { TextField } from '@components/text-field';

import { api } from 'api';

import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

const SSOSignin = observer(({ closeModal, email }) => {
  const { t } = useStore();
  const location = useLocation();
  const locationState = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [ssoEmail, setSsoEmail] = useState(email);
  const client = useQueryClient();

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      signInSSO();
    }
  }

  async function signInSSO() {
    const res = await api.companies.loadAzureADSettings(ssoEmail);
    if (res.error) {
      if (res.data.errorCode.includes('101')) {
        setError(t('modals.sso.errors.account_not_configured'));
      } else if (res.data.errorCode.includes('102')) {
        setError(t('modals.sso.errors.company_not_configured'));
      } else {
        setError(res.data.email);
      }
      return;
    }
    const { clientId, tenantId } = res.data;
    const msalConfig = {
      auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
      },
    };
    const msalInstance = new Msal.UserAgentApplication(msalConfig);
    var loginRequest = {
      scopes: ['user.read'],
    };

    msalInstance.loginPopup(loginRequest).then((response) => {
      api.users.signInAzureAD(response.idToken.rawIdToken, ssoEmail).then((res) => {
        if (!res.error) {
          client.resetQueries();
          const redir = locationState && (locationState.from ? locationState.from : '/');
          closeModal();
          navigate(redir);
        } else {
          if (res.data.errorCode.includes('101')) {
            setError(t('modals.sso.errors.account_not_configured'));
          } else if (res.data.errorCode.includes('102')) {
            setError(t('modals.sso.errors.company_not_configured'));
          } else {
            setError(res.data.email);
          }
        }
      });
    });
  }

  return (
    <Modal>
      <Modal.Header text={t('modals.sso.header')} />
      <TextField
        autoFocus
        iconLeft={<IconEmail />}
        label={t('modals.sso.email')}
        error={error}
        onChange={(val) => setSsoEmail(val)}
        value={ssoEmail}
        onKeyPress={handleKeyPress}
      />
      <Modal.Actions>
        <Button variant="secondary" onClick={closeModal} text={t('modals.sso.button.cancel')} />
        <Button
          style={{ marginLeft: 16 }}
          onClick={signInSSO}
          text={t('modals.sso.button.signin')}
        />
      </Modal.Actions>
    </Modal>
  );
});

export default SSOSignin;
